/**
 * Constantes globales de la app: versión, eventos, rutas base de API por
 * entorno/marca, assets de marca y utilidades comunes. Las rutas de cada RPC
 * gRPC-Web viven en sus propios `*_pb.ts` generados, no acá.
 */

// --- Versión de la app ---
/** Versión de la aplicación. */
export const APP_VERSION: string = "1.0.0";

// --- Eventos del DOM (navegación/recarga de la app) ---
/** Evento custom para navegar entre páginas. */
export const EVENT_APP_NAVIGATE: string = "app:navigate";
/** Evento custom para recargar la página actual. */
export const EVENT_APP_RELOAD: string = "app:reload";

// --- Rutas base de API por entorno y marca ---
// En release cada marca va a su host. Nitrofert y Agro360 van a api-nitrofert.sextantedrones.com
// desde el 2026-10-18: su API dejo el App Service de api.gro-360.com y paso al servidor de Sextante,
// con un subdominio propio (ver CLAUDE.md del Server, "Publicacion de Nitrofert Release en Docker").
export const TESTING_NITROFERT_API_ROUTE: string =
  "https://nitrofert-api-test.sextantedrones.com";
export const TESTING_SEXTANTE_API_ROUTE: string =
  "https://api-test.sextantedrones.com";

export const RELEASE_NITROFERT_API_ROUTE: string =
  "https://api-nitrofert.sextantedrones.com";
export const RELEASE_SEXTANTE_API_ROUTE: string =
  "https://api.sextantedrones.com";

// En testing Agro360 va a la Api de pruebas de Nitrofert, igual que Nitrofert (apuntaba por error a la de
// Sextante; corregido el 2026-11-01).
export const TESTING_AGRO360_API_ROUTE: string =
  "https://nitrofert-api-test.sextantedrones.com";
export const RELEASE_AGRO360_API_ROUTE: string =
  "https://api-nitrofert.sextantedrones.com";

// --- Google Maps ---
/** API key de Google Maps (tiles satelitales). */
export const GOOGLE_MAPS_API_KEY: string =
  "AIzaSyBmaNcwYynVMXHhKQWQUwXzQR6IY4OO_CA";
//"AIzaSyAO5tXWl05SVWbQkNqi_BAP1f3A_CaUD6Y";

// --- Mapa del registro de finca (wizard de crear/editar finca) ---
// La web ya no habla con GeoServer ni conoce su dirección ni sus credenciales
// (2026-10-11): las imágenes van por la Api (`/mapa/registro-finca/wms`, con un
// ticket del registro) y las lecturas y escrituras de geometría por gRPC. Las
// claves de capa y la URL viven en
// `shared/components/modulos/terceros/finca/map/MapaRegistroFinca.ts`.

// --- Storage de ortomosaico público (sin SAS) ---
/** Prefijo de `uriOrtomosaico` servido desde este contenedor: no requiere SAS
 *  de lectura (a diferencia del contenedor privado de `storage/tiles/sas-read`
 *  que usa el resto de las capas de tiles). */
export const ORTOMOSAICO_PUBLIC_URI_PREFIX: string =
  "https://ernestogverp.blob.core.windows.net/";

// --- Assets y título de la marca Sextante ---
export const SEXTANTE_LOGO_ROUTE: string = "assets/sextante_logo.png";
export const SEXTANTE_BRAND_ROUTE: string = "assets/sextante_brand.png";
export const SEXTANTE_DEFAULT_TITLE: string = "DATA AG";

// --- Assets y título de la marca Nitrofert: el producto se llama Nitria (antes SOIL) ---
export const NITROFERT_LOGO_ROUTE: string = "assets/nitria_logo.png";
export const NITROFERT_BRAND_ROUTE: string = "assets/nitria_brand.png";
export const NITROFERT_DEFAULT_TITLE: string = "Nitria";
/** Login del portal de Nitria: a donde va la app Nitrofert sin sesión válida
 *  (SSO, decidido 2026-09-30). Depende del ambiente (2026-10-05): en debug y
 *  testing, el portal de desarrollo; en release, el de producción. */
export const TESTING_NITROFERT_PORTAL_LOGIN_URL: string =
  "https://portal-apps-dev.nitrofert.com.co/auth/login";
export const RELEASE_NITROFERT_PORTAL_LOGIN_URL: string =
  "https://apps.nitria.com.co/";

// --- Assets y título de la marca Agro360 ---
export const AGRO360_LOGO_ROUTE: string = "assets/agro360_logo.png";
export const AGRO360_BRAND_ROUTE: string = "assets/agro360_brand.png";
export const AGRO360_DEFAULT_TITLE: string = "Santander Agro360";
